module.exports = __webpack_public_path__ + "static/media/cq_sottolineato.4b169ab6.svg";